module.exports = __webpack_public_path__ + "static/helmo-250c5561d49092c3a68980d885648eb0.png";